<div class="container-fluid">
  <div class="col-12">
    <h4 class="d-flex flex-row align-items-center justify-content-center font-weight-normal" >
      <p class="text-justify">{{"accounts.referred.code.general1" | translate }}<b>{{productName}}</b>{{"accounts.referred.code.general2" | translate }}<b>{{productName}}</b>{{"accounts.referred.code.general3" | translate }}</p>
    </h4>
    <div  class="d-flex flex-row align-items-center justify-content-center font-weight-normal">
      <h3>{{ "accounts.referred.code.title" | translate }}<b>{{ referralCode | lowercase }}</b></h3>
      <button *ngIf="referralCode" class="btn btn-primary copy-button" (click)="copyReferralCode()"><i class="fas fa-copy"></i>&nbsp;{{ "accounts.referred.code.copy" | translate }}</button>
    </div>
    <br>
    <p class="text-justify">{{ "accounts.referred.code.step1" | translate }}</p>
    <div class="d-flex align-items-center justify-content-center">
      <div class="bg-primary p-2">
        <img class="img-fluid img-lg" src="/assets/images/step1-spanish.png" alt="Process1" *ngIf="!changeImage">
        <img class="img-fluid img-lg"  src="/assets/images/step1-english.png" alt="Process1" *ngIf="changeImage">
      </div>
    </div>
    <div class="d-flex flex-row">
      <p class="text-justify">{{ "accounts.referred.code.step2-part1" | translate }}<b class="code-size">{{referralCode | lowercase }}</b>{{ "accounts.referred.code.step2-part2" | translate }}</p>
    </div>
    <div class="d-flex align-items-center justify-content-center">
      <div class="bg-primary p-2">
        <img class="img-fluid img-lg" src="/assets/images/step2-spanish.png" alt="Process2" *ngIf="!changeImage">
        <img class="img-fluid img-lg" src="/assets/images/step2-english.png" alt="Process2" *ngIf="changeImage">
      </div>
    </div>
    <p class="text-justify">{{"accounts.referred.code.step3" | translate }}</p>
    <div class="d-flex align-items-center justify-content-center">
      <div class="bg-primary p-2">
        <img class="img-fluid img-lg" src="/assets/images/step3-spanish.png" alt="Process3" *ngIf="!changeImage">
        <img class="img-fluid img-lg" src="/assets/images/step3-english.png" alt="Process3" *ngIf="changeImage">
      </div>
    </div>
    <br>
    <div class="d-flex flex-row">
      <p class="text-justify">{{"accounts.referred.code.end-step" | translate }}<b>{{productName}}</b>.</p>
    </div>
    <br>
    <hr>
    <p class="text-justify">{{"accounts.referred.code.account-instructions" | translate }}</p>
    <div class="d-flex align-items-center justify-content-center">
      <div class="bg-primary p-2">
        <img class="img-fluid img-lg" src="/assets/images/referral-spanish.png" alt="menu" *ngIf="!changeImage">
        <img class="img-fluid img-lg" src="/assets/images/referral-english.png" alt="menu" *ngIf="changeImage">
      </div>
    </div>
  </div>
</div>
